import type {
  GetViewupPlusSnsAccountsByUserUuidDataElementDto,
  GetViewupSnsAccountsByUserUuidDataElementDto,
  PlatformCategoryCategoryEnum,
} from 'viewup-api';

export type ViewupAndViewupPlusTypes = (GetViewupSnsAccountsByUserUuidDataElementDto &
  GetViewupPlusSnsAccountsByUserUuidDataElementDto)[];

export type SnsTypes = PlatformCategoryCategoryEnum | 'viewupPlus';

export type ErrorObjectType =
  | { field: string; message: string; type: 'field' }
  | {
      image?: string;
      message: string;
      twoFactorMethod: TwoFactorMethod;
      type: 'twoFactor';
    }
  | { message: string; type: 'message' };

export type TwoFactorMethod = 'sms' | 'otp' | 'device' | 'whatsapp' | 'email' | 'image';

export type InstagramSelectType = '' | 'viewing' | 'plus';

export type FormFieldValues = {
  authCode: string;
  id: string;
  naverCaptcha?: string;
  password: string;
};

export enum SnsEarnViewingBehavior {
  Click = 'click',
  Plus = 'plus',
  Posting = 'posting',
}
